/**
 * Le seul JavaScript servi par un site de galerie (section 7.3) : il améliore
 * les deux formulaires dynamiques, il ne les fait pas exister. Sans lui, le
 * navigateur poste normalement vers `/api/contact` ou `/api/newsletter`, que
 * Caddy route vers l'API ; l'API répond alors par une redirection.
 *
 * Aucune dépendance, aucun suivi, aucune requête au chargement.
 */
export const CHEMIN_SCRIPT = '/assets/site.js';
export const SCRIPT_FORMULAIRES = `(function () {
  'use strict';
  if (!('fetch' in window) || !('FormData' in window)) return;

  function etat(formulaire, texte, erreur) {
    var zone = formulaire.querySelector('[data-etat]');
    if (!zone) return;
    zone.textContent = texte;
    zone.setAttribute('data-erreur', erreur ? 'oui' : 'non');
  }

  function envoyer(formulaire) {
    var action = formulaire.getAttribute('action');
    var bouton = formulaire.querySelector('button[type="submit"]');
    var succes = formulaire.getAttribute('data-succes') || '';
    var echec = formulaire.getAttribute('data-echec') || '';
    if (bouton) bouton.disabled = true;
    etat(formulaire, formulaire.getAttribute('data-envoi') || '', false);
    fetch(action, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(formulaire),
    })
      .then(function (reponse) {
        if (!reponse.ok) throw new Error(String(reponse.status));
        formulaire.reset();
        etat(formulaire, succes, false);
      })
      .catch(function () {
        etat(formulaire, echec, true);
      })
      .then(function () {
        if (bouton) bouton.disabled = false;
      });
  }

  var formulaires = document.querySelectorAll('form[data-api]');
  for (var i = 0; i < formulaires.length; i += 1) {
    (function (formulaire) {
      formulaire.addEventListener('submit', function (evenement) {
        evenement.preventDefault();
        envoyer(formulaire);
      });
    })(formulaires[i]);
  }
})();
`;
//# sourceMappingURL=formulaires.js.map